"use strict";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
import $ from "jquery";
import "typeahead.js";
$.fn.typeahead = $.fn.typeahead.noConflict();
var TypeAhead = React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    return this.stateFromProps(this.props);
  },
  stateFromProps: function(props) {
    return {
      term: props.selectedItem ? this.restingDisplay(props.selectedItem) : "",
      selectedItem: props.selectedItem
    };
  },
  componentWillReceiveProps: function(newProps) {
    if (this.props.selectedItem !== newProps.selectedItem) {
      this.setState(this.stateFromProps(newProps));
    }
  },
  componentDidMount: function() {
    var component = this;
    var element = ReactDOM.findDOMNode(this);
    $(element).typeahead(
      {
        minLength: 1,
        highlight: false
      },
      {
        name: "type-ahead",
        displayKey: function(c) {
          return c ? this.restingDisplay(c) : "";
        }.bind(this),
        source: function(term, callback) {
          if (this.props.remoteSearch) {
            this.props.remoteSearch(term).then(function(data) {
              callback(data);
            });
          } else {
            callback(this.props.search(term));
          }
        }.bind(this),
        templates: {
          empty: '<div class="tt-no-matches">No matches found</div>',
          suggestion: function(match) {
            return this.props.display(match);
          }.bind(this)
        }
      }
    );
    var selectItem = function(typeaheadEvent, item) {
      component.setState({
        term: component.restingDisplay(item),
        selectItem: item
      });
      component.props.onSelectItem(item);
      $(element).typeahead("close");
    };
    $(element).on("typeahead:selected", selectItem);
    $(element).on("typeahead:autocompleted", selectItem);
    $(element).on("typeahead:closed", function(jquery, item) {
      if (!component.state.selectedItem && !component.props.readOnly) {
        component.setState({
          term: ""
        });
        component.props.onClearSelectedItem();
      }
      if (_.isEmpty(element.value) && !_.isEmpty(component.state.term)) {
        $(element).typeahead("val", component.state.term);
      }
    });
  },
  componentWillUnmount: function() {
    var element = ReactDOM.findDOMNode(this);
    $(element).typeahead("destroy");
  },
  focused: function(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  },
  myLinkState: function(field) {
    return {
      value: this.state[field],
      requestChange: function(value) {
        var newState = {};
        newState[field] = value;
        this.setState(newState);
        this.setState({ selectedItem: null });
        if (value === "") {
          const onClearSelectedItem = this.props.onClearSelectedItem;
          if (onClearSelectedItem) {
            this.props.onClearSelectedItem();
          }
        }
      }.bind(this)
    };
  },
  dropped: function(term) {
    var element = ReactDOM.findDOMNode(this);
    this.setState({ selectedItem: null, term });
    $(element).trigger("focus");
    $(element).trigger("input");
  },
  render: function() {
    if (this.props.isDroppable) {
      return /* @__PURE__ */ React.createElement(
        ValueLinkTextDroppableInput,
        {
          "data-component": "TypeAhead",
          type: "text",
          typeahead: true,
          disabled: this.props.readOnly,
          valueLink: this.myLinkState("term"),
          inputDropped: this.dropped,
          onFocus: this.focused,
          className: "carrier-setter__typeahead mousetrap-allow-text",
          placeholder: this.props.placeHolder,
          onKeyPress: this.keyPress,
          showTextArea: this.props.showTextArea
        }
      );
    } else {
      if (this.props.showTextArea) {
        return /* @__PURE__ */ React.createElement(
          "textarea",
          {
            type: "text",
            disabled: this.props.readOnly,
            valueLink: this.myLinkState("term"),
            onFocus: this.focused,
            className: "carrier-setter__typeahead mousetrap-allow-text",
            placeholder: this.props.placeHolder,
            onKeyPress: this.keyPress,
            rows: 1
          }
        );
      } else {
        return /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            disabled: this.props.readOnly,
            valueLink: this.myLinkState("term"),
            onFocus: this.focused,
            className: "carrier-setter__typeahead mousetrap-allow-text",
            onKeyPress: this.keyPress,
            placeholder: this.props.placeHolder
          }
        );
      }
    }
  },
  restingDisplay: function(item) {
    return this.props.display(item).replace(/<br>/g, " - ");
  },
  keyPress: function(e) {
    if (e.charCode === 13) {
      e.preventDefault();
      if (this.state.selectedItem && this.props.onSubmit) {
        this.props.onSubmit();
      }
    }
  }
});
export default TypeAhead;
